module.exports = __webpack_public_path__ + "img/popeye1.77aa3da9.jpg";